<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Listagem Centro de Custo por Planta
      </p>
    </div>
    <div>
      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-3">
          Centro de custo:

          <q-select
            class="input-new-design"
            dense
            outlined
            use-input
            option-value="id"
            option-label="name"
            map-options
            :options="listaCentroCusto"
            @filter="filtrarCentroCusto"
            v-model="filtros.centroCusto"
          />
        </div>

        <div class="col-md-1 q-ml-sm q-mt-lg">
          <q-btn
            @click="getDados()"
            icon="filter_alt"
            no-caps
            style="background-color: #7ab9e0; border-radius: 8px; color: white"
            label="Filtrar"
          />
        </div>
      </div>

      <div class="col-md-1 q-ml-sm q-mt-lg">
        <q-btn
          @click="rightDrawerOpen = true"
          icon="add"
          color="brand-1"
          no-caps
          style="border-radius: 8px; color: white"
          label="Criar"
        />
      </div>

      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        dense
        :columns="columns"
        v-model:pagination="pagination"
        class="tabela-tamanho-fixo q-mt-md"
        row-key="name"
        :rows-per-page-options="[0]"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template #body-cell-vendor_name="props">
          <q-td>
            <span v-if="!props.row.isEdit">{{ props.row.vendor_name }}</span>

            <q-input
              v-else
              class="input-new-design"
              dense
              outlined
              v-model="props.row.vendor_name"
            />
          </q-td>
        </template>
        <template #body-cell-cost_center_id="props">
          <q-td>
            <span v-if="!props.row.isEdit">{{ props.row.cost_center_id }}</span>

            <q-input
              v-else
              class="input-new-design"
              dense
              outlined
              v-model="props.row.cost_center_id"
            />
          </q-td>
        </template>
        <template #body-cell-cost_center_code="props">
          <q-td>
            <span v-if="!props.row.isEdit">{{
              props.row.cost_center_code
            }}</span>

            <q-input
              v-else
              class="input-new-design"
              dense
              outlined
              v-model="props.row.cost_center_code"
            />
          </q-td>
        </template>
        <template #body-cell-cost_center_name="props">
          <q-td>
            <span v-if="!props.row.isEdit">
              {{ props.row.cost_center_name }}</span
            >

            <q-input
              v-else
              class="input-new-design"
              dense
              outlined
              v-model="props.row.cost_center_name"
            />
          </q-td>
        </template>
        <template #body-cell-branch_code="props">
          <q-td>
            <span v-if="!props.row.isEdit">{{ props.row.branch_code }}</span>

            <q-input
              v-else
              class="input-new-design"
              dense
              outlined
              v-model="props.row.branch_code"
            />
          </q-td>
        </template>

        <template #body-cell-delete="props">
          <q-td>
            <q-btn
              @click="
                (saveLastSelectedId = props.row.id), (excluirDialog = true)
              "
              round
              flat
              color="negative"
              icon="sym_o_delete"
            />
          </q-td>
        </template>

        <template #body-cell-editar="props">
          <q-td>
            <q-btn
              v-if="!props.row.isEdit"
              @click="props.row.isEdit = true"
              round
              flat
              color="brand-1"
              icon="sym_o_edit"
            />
            <q-btn
              v-else
              @click="editarCentro(props.row), (props.row.isEdit = false)"
              round
              flat
              color="positive"
              icon="sym_o_done"
            />
          </q-td>
        </template>
      </q-table>
    </div>
    <q-dialog v-model="rightDrawerOpen" position="right">
      <q-card style="width: 400px" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpen = false"
            />
            <span style="font-size: 16px" class="texto-titulo-modal"
              >Criar Novo
            </span>
          </div>
        </div>
        <q-card-section class="column no-wrap">
          <div class="q-mt-sm">
            <span>Unidade Nome</span>

            <q-select
              class="input-new-design"
              dense
              outlined
              use-input
              option-value="id"
              option-label="nome"
              map-options
              emit-value
              :options="$store.state.org.todaUnidades"
              v-model="novoCentro.vendor_id"
            />
          </div>
          <div class="q-mt-sm">
            <span>Centro de Custo ID</span>

            <q-select
              class="input-new-design"
              dense
              outlined
              use-input
              option-value="id"
              option-label="name"
              map-options
              emit-value
              :options="listaCentroCusto"
              @filter="filtrarCentroCusto"
              v-model="novoCentro.cost_center_id"
            />
          </div>
          <div class="q-mt-sm">
            <span>Planta</span>
            <q-input
              class="input-new-design"
              dense
              outlined
              v-model="novoCentro.branch_code"
            />
          </div>

          <q-btn
            :disabled="validarCampos()"
            icon="done"
            color="positive"
            no-caps
            class="q-mt-sm"
            style="border-radius: 8px; color: white"
            @click="criarCentro"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
    <dialog-info-design
      mensagem="Confirma Exclusão?"
      subMensagem="Tem certeza que deseja desligar excluir esse centro?"
      :exibir="excluirDialog"
      :showCancelar="true"
      @resultado="removerCentro"
    />
  </q-page>
</template>

<script>
const columns = [
  {
    name: "vendor_name",
    label: "Unidade nome",
    field: "vendor_name",
    align: "left",
  },
  {
    name: "cost_center_id",
    label: "CC ID",
    field: "cost_center_id",
    align: "left",
  },
  {
    name: "cost_center_code",
    label: "CC codigo",
    field: "cost_center_code",
    align: "left",
  },
  {
    name: "cost_center_name",
    label: "CC Nome",
    field: "cost_center_name",
    align: "left",
  },
  {
    name: "branch_code",
    label: "Planta",

    align: "left",
    field: "branch_code",
  },

  {
    name: "created_at",
    label: "Data Criação",
    field: (row) =>
      row.created_at?.split(" ")[0]?.split("-")?.reverse()?.join("/"),
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    field: "editar",
    align: "left",
  },
  {
    name: "delete",
    label: "Excluir",
    field: "delete",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
export default {
  components: { DialogInfoDesign },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const rightDrawerOpen = ref(false);
    const disable = ref(true);
    const listaCentroCusto = ref([]);
    const saveLastSelectedId = ref(null);
    const excluirDialog = ref(false);
    const filtros = ref({
      centroCusto: "",
    });
    const novoCentro = ref({
      vendor_name: "",
      cost_center_id: "",
      cost_center_code: "",
      cost_center_name: "",
      branch_code: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async (page = 0, rowsPerPage = 15) => {
      try {
        let response = await store.dispatch("integracao/listarCentrosPlanta", {
          cost_center_code: filtros.value?.centroCusto?.code,
          page: page,
          per_page: rowsPerPage,
        });

        rows.value = response.data.data.map((item) => {
          return {
            ...item,
            isEdit: false,
          };
        });

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );
    const listarCentroCustos = async (val) => {
      await store.state.autenticacao.cliente;
      await store.state.org.unidadeData.id;
      try {
        const response = await store.dispatch(
          "integracao/listarCentrosCustos",
          {
            per_page: 10,
            vendor_id: store.state.org.unidadeData.id,
            search: val,
          }
        );
        listaCentroCusto.value = response.data.results.data;
      } catch (error) {
        console.log(error);
      }
    };

    function filtrarCentroCusto(val, update) {
      listarCentroCustos(val);
      setTimeout(() => {
        update();
      }, 500);
    }

    const removerCentro = async (resultado) => {
      excluirDialog.value = false;
      if (resultado) {
        try {
          await store.dispatch("integracao/removerCentro", {
            id: saveLastSelectedId.value,
          });

          quasar.notify({
            message: "Centro excluido com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getDados();
        } catch (error) {
          quasar.notify({
            message: "Nenhuma filial foi encontrada com o id informado.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          console.log(error);
        }
      }
    };

    const criarCentro = async (idCentro) => {
      try {
        await store.dispatch("integracao/criarCentro", {
          id: idCentro,
          vendor_id: novoCentro.value.vendor_id,
          vendor_name: novoCentro.value.vendor_name,
          cost_center_id: novoCentro.value.cost_center_id,
          cost_center_code: novoCentro.value.cost_center_code,
          branch_code: novoCentro.value.branch_code,
        });

        quasar.notify({
          message: "Centro criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
        rightDrawerOpen.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o criar centro.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        console.log(error);
      }
    };

    const editarCentro = async (row) => {
      try {
        await store.dispatch("integracao/editarCentro", {
          id: row.id,
          vendor_id: row.vendor_id,
          vendor_name: row.vendor_name,
          cost_center_id: row.cost_center_id,
          cost_center_code: row.cost_center_code,
          cost_center_name: row.cost_center_name,
          branch_code: row.branch_code,
        });

        quasar.notify({
          message: "Centro excluido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        quasar.notify({
          message: "Nenhuma filial foi encontrada com o id informado.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        console.log(error);
      }
    };

    const validarCampos = () => {
      return (
        !novoCentro.value.vendor_id ||
        !novoCentro.value.cost_center_id ||
        !novoCentro.value.branch_code
      );
    };

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      validarCampos,
      saveLastSelectedId,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      pagination,
      removerCentro,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      listaCentroCusto,
      filtrarCentroCusto,
      editarCentro,
      rightDrawerOpen,
      novoCentro,
      criarCentro,
      excluirDialog,
    };
  },
};
</script>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>

<style scoped>
.drawer-modal {
  border: 2px solid black;

  right: 0;
  width: 450px;

  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
</style>
